import {
  eapToHpi0SessionLeftAddHpiLinkText,
  eapToHpi0SessionLeftAddPaymentLinkText,
  eapToHpi0SessionLeftDependentDescriptionText,
  eapToHpi0SessionLeftDependentViewCostLinkText,
  eapToHpi0SessionLeftSelfDescriptionText,
  eapToHpi0SessionLeftSelfViewCostLinkText,
  eapToHpi1SessionLeftDependentAddHpiLinkText,
  eapToHpi1SessionLeftDependentAddPaymentLinkText,
  eapToHpi1SessionLeftDependentDescriptionText,
  eapToHpi1SessionLeftSelfAddHpiLinkText,
  eapToHpi1SessionLeftSelfAddPaymentLinkText,
  eapToHpi1SessionLeftSelfDescriptionText,
  eapToHpi1SessionLeftViewCostLinkText,
} from '../messages'
import { EapHpiNotificationType } from './useEapHpiBannerState'

interface UseGetEapToHpiEligibilityTextProps {
  flowAs?: string
  sessionsRemaining?: number
  notificationType?: EapHpiNotificationType
}

export enum EAP_TO_HPI_LINK_DESTINATION {
  ADD_HPI,
  ADD_PAYMENT,
  VIEW_COST,
}

const textLookup = {
  oneSession_dependent: {
    descriptionText: eapToHpi1SessionLeftDependentDescriptionText,
    linkConfig: {
      [EapHpiNotificationType.ADD_HEALTH_PLAN]: {
        linkText: eapToHpi1SessionLeftDependentAddHpiLinkText,
        linkDestination: EAP_TO_HPI_LINK_DESTINATION.ADD_HPI,
      },
      [EapHpiNotificationType.ADD_PAYMENT_INFO]: {
        linkText: eapToHpi1SessionLeftDependentAddPaymentLinkText,
        linkDestination: EAP_TO_HPI_LINK_DESTINATION.ADD_PAYMENT,
      },
      [EapHpiNotificationType.VIEW_COST_ESTIMATE]: {
        linkText: eapToHpi1SessionLeftViewCostLinkText,
        linkDestination: EAP_TO_HPI_LINK_DESTINATION.VIEW_COST,
      },
    },
  },
  zeroSession_dependent: {
    descriptionText: eapToHpi0SessionLeftDependentDescriptionText,
    linkConfig: {
      [EapHpiNotificationType.ADD_HEALTH_PLAN]: {
        linkText: eapToHpi0SessionLeftAddHpiLinkText,
        linkDestination: EAP_TO_HPI_LINK_DESTINATION.ADD_HPI,
      },
      [EapHpiNotificationType.ADD_PAYMENT_INFO]: {
        linkText: eapToHpi0SessionLeftAddPaymentLinkText,
        linkDestination: EAP_TO_HPI_LINK_DESTINATION.ADD_PAYMENT,
      },
      [EapHpiNotificationType.VIEW_COST_ESTIMATE]: {
        linkText: eapToHpi0SessionLeftDependentViewCostLinkText,
        linkDestination: EAP_TO_HPI_LINK_DESTINATION.VIEW_COST,
      },
    },
  },
  oneSession_self: {
    descriptionText: eapToHpi1SessionLeftSelfDescriptionText,
    linkConfig: {
      [EapHpiNotificationType.ADD_HEALTH_PLAN]: {
        linkText: eapToHpi1SessionLeftSelfAddHpiLinkText,
        linkDestination: EAP_TO_HPI_LINK_DESTINATION.ADD_HPI,
      },
      [EapHpiNotificationType.ADD_PAYMENT_INFO]: {
        linkText: eapToHpi1SessionLeftSelfAddPaymentLinkText,
        linkDestination: EAP_TO_HPI_LINK_DESTINATION.ADD_PAYMENT,
      },
      [EapHpiNotificationType.VIEW_COST_ESTIMATE]: {
        linkText: eapToHpi1SessionLeftViewCostLinkText,
        linkDestination: EAP_TO_HPI_LINK_DESTINATION.VIEW_COST,
      },
    },
  },
  zeroSession_self: {
    descriptionText: eapToHpi0SessionLeftSelfDescriptionText,
    linkConfig: {
      [EapHpiNotificationType.ADD_HEALTH_PLAN]: {
        linkText: eapToHpi0SessionLeftAddHpiLinkText,
        linkDestination: EAP_TO_HPI_LINK_DESTINATION.ADD_HPI,
      },
      [EapHpiNotificationType.ADD_PAYMENT_INFO]: {
        linkText: eapToHpi0SessionLeftAddPaymentLinkText,
        linkDestination: EAP_TO_HPI_LINK_DESTINATION.ADD_PAYMENT,
      },
      [EapHpiNotificationType.VIEW_COST_ESTIMATE]: {
        linkText: eapToHpi0SessionLeftSelfViewCostLinkText,
        linkDestination: EAP_TO_HPI_LINK_DESTINATION.VIEW_COST,
      },
    },
  },
}

export const useGetEapToHpiEligibilityText = (props: UseGetEapToHpiEligibilityTextProps) => {
  const { notificationType, sessionsRemaining, flowAs } = props

  let descriptionText
  let linkText
  let linkDestination

  if (notificationType != null && sessionsRemaining != null && flowAs != null) {
    const lookupSessionKey = sessionsRemaining === 1 ? 'oneSession' : 'zeroSession'
    const lookupDependentKey = flowAs == 'minor_dependent' ? 'dependent' : 'self'
    const lookupKey = `${lookupSessionKey}_${lookupDependentKey}` as const

    descriptionText = textLookup[lookupKey]?.descriptionText

    const linkConfig = textLookup[lookupKey]?.linkConfig
    linkText = linkConfig?.[notificationType]?.linkText
    linkDestination = linkConfig?.[notificationType]?.linkDestination
  }

  return {
    descriptionText,
    linkText,
    linkDestination,
  }
}
